import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Instagram, Twitter, Facebook } from "lucide-react";
export default function BrandFootnote() {
  const shopLinks = [{
    label: "Concrete Pouring",
    href: "#"
  }, {
    label: "Structural Foundations",
    href: "#"
  }, {
    label: "Custom Masonry",
    href: "#"
  }, {
    label: "Our Projects",
    href: "/ProjectsPage"
  }];
  const supportLinks = [{
    label: "Contact Us",
    href: "/ContactPage"
  }, {
    label: "Safety Standards",
    href: "#"
  }, {
    label: "Our Process",
    href: "#"
  }, {
    label: "Careers",
    href: "#"
  }];
  const socialLinks = [{
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }];
  return <section data-section-id="28060" id="footer" className="dark bg-background text-foreground py-20 border-t border-border/20">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {}
          <div className="flex flex-col space-y-6">
            <Link to="#" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621168/img/sampson_concrete_logo.png" alt="Sampson Concrete & Masonry" className="h-7 w-auto opacity-90 hover:opacity-100 transition-opacity" />
            </Link>
            <p className="text-muted-foreground text-sm font-sans leading-relaxed max-w-xs">
              Delivering structural integrity and precision craftsmanship in concrete and masonry. Sampson Concrete & Masonry builds the foundations for tomorrow's landmarks.
            </p>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-sm font-black uppercase tracking-tighter text-foreground font-sans">
              Services
            </h3>
            <ul className="space-y-4">
              {shopLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-muted-foreground hover:text-primary transition-colors text-xs font-mono">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-sm font-black uppercase tracking-tighter text-foreground font-sans">
              Company
            </h3>
            <ul className="space-y-4">
              {supportLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-muted-foreground hover:text-primary transition-colors text-xs font-mono">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-sm font-black uppercase tracking-tighter text-foreground font-sans">
              Connect
            </h3>
            <div className="flex items-center gap-6">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} className="text-muted-foreground hover:text-primary transition-colors group" aria-label={social.label} data-index={i}>
                    <Icon strokeWidth={2} className="w-6 h-6 group-hover:scale-110 transition-transform duration-300" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        <Separator className="my-12 bg-border/20" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground font-mono">
          <p>
            &copy; {new Date().getFullYear()} Sampson Concrete & Masonry. Precision in every pour.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}